'use strict';

var schema = Object.assign({}, require('./chain_types.json'), require('./eosio_system.json'), require('./eosio_token.json'));

module.exports = schema;


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs/lib/schema/index.js
// module id = 116
// module chunks = 0